/**
 * Creates a text texture using a canvas and returns it as a THREE.CanvasTexture along with its aspect ratio.
 * 
 * @param {string} [text=''] - The text to render on the texture.
 * @param {number} [fontSize=20] - The font size of the text.
 * @param {string} [color='#ffffff'] - The fill color of the text.
 * @param {string} [colorContour='#1d1d1d65'] - The stroke color (contour) of the text.
 * @returns {{ texture: THREE.CanvasTexture, aspect: number }} An object containing the generated texture and its aspect ratio.
 */
import * as THREE from 'three';

function createTextTexture(text = '', fontSize = 20, color = '#ffffff', colorContour = '#1d1d1d65') {

    const scaleFactor = 2; // For high DPI displays
    const padding = fontSize * 0.5;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    //measure text width
    ctx.font = `Bold ${fontSize}px Trebuchet MS , Georgia, "Helvetica", "Arial"`;
    const textWidth = ctx.measureText(text).width;

    const width = (textWidth + padding * 2) * scaleFactor; // Increase resolution
    const height = (fontSize * 1.5 + padding) * scaleFactor;
    canvas.width = width;
    canvas.height = height;

    // for sharper rendering
    ctx.scale(scaleFactor, scaleFactor);
    // Apply styles again after scaling
    ctx.font = `Bold ${fontSize}px Trebuchet MS , Georgia, "Helvetica", "Arial"`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.lineWidth = 1; // Stroke width
    ctx.strokeStyle = colorContour;
    ctx.strokeText(text, width / (2 * scaleFactor), height / (2 * scaleFactor) + 1);

    // Draw text in the center
    ctx.fillStyle = color;
    ctx.fillText(text, width / (2 * scaleFactor), height / (2 * scaleFactor));

    const texture = new THREE.CanvasTexture(canvas);
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;

    return { texture, aspect: width / height };
}

export default {
    createTextTexture,
};